import { clsx } from 'clsx';
import { FC, useCallback } from 'react';
import { Paragraph } from '@alto-avios/alto-ui';

import { MegaNavSectionData, NavItemData } from '../../../services/content';

import { MegaNavSectionLink } from './MegaNavSectionLink';
import styles from './MegaNavSection.module.scss';

export interface MegaNavSectionProps {
  data: MegaNavSectionData;
  onLinkPress: (section: MegaNavSectionData, link: NavItemData, position: number) => void;
}

export const MegaNavSection: FC<MegaNavSectionProps> = ({ onLinkPress, data }) => {
  const handleLinkPress = useCallback(
    (link: NavItemData) => {
      onLinkPress(data, link, data.links.indexOf(link));
    },
    [onLinkPress, data]
  );

  return (
    <div className={clsx(styles.contentSection)}>
      <div title={data.header} className={styles.header} role="heading">
        <Paragraph size="sm">{data.header}</Paragraph>
      </div>
      <div className={styles.linksContainer}>
        {data.links?.map((link) => <MegaNavSectionLink key={link.label} link={link} onPress={handleLinkPress} />)}
      </div>
    </div>
  );
};
